<template>
  <div>
    <home-pay v-if="type === 1" />
    <home-doctor v-else />
  </div>
</template>

<script>
import homePay from "./home_pay.vue";
import homeDoctor from "./home_doctor.vue";
export default {
  components: {
    homePay,
    homeDoctor
  },
  data() {
    return {
      type: 1 //1:支付，2：就医凭证
    };
  },
  created() {
    this.type = window.location.href.indexOf("www") > -1 ? 1 : 2;
  }
};
</script>

<style>
</style>